import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { postCandidateCv} from "@/api/candidateProfile.jsx"
import {getCandidateCv} from "@/api/candidate/candidatePersonalData.jsx";
import FileUpload from "@/components/FileUpload.jsx"
import { Loader } from "@/components/ui/loader"
import {BackButton} from "@/components/ui/BackButton.jsx";

export default function CvUploadForm() {
    const [upload, setUpload] = useState(null)
    const [cvDoc, setCvDoc] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function load() {
            try {
                const res = await getCandidateCv()
                setCvDoc(res)
                console.log(res)
            } catch (err) {
                console.error("Failed to load CV", err)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [])

    const handleFileChange = (file) => {
        setUpload(file)
    }

    const handleUpload = async () => {
        if (!upload) return

        try {
            const res = await postCandidateCv(upload)
            setCvDoc(res)
            setUpload(null)
        } catch (err) {
            console.error("CV Upload error:", err)
            alert("Failed to upload CV. Please try again.")
        }
    }

    if (loading) return <Loader />

    return (
        <div className="space-y-4   p-3 bg-brand-25 h-full">
            <BackButton to="/profile/candidate" />
            <Label className="block font-medium text-base">Upload Your CV</Label>
            <div className="space-y-2">
                {cvDoc?.fileExists && (
                    <Button
                        className="bg-brand-500"
                        size="sm"
                        onClick={() => window.open(cvDoc.documentUrl, "_blank")}
                    >
                        View Current CV
                    </Button>
                )}

                <FileUpload
                    label="Upload Your CV"
                    accept=".pdf,.doc,.docx"
                    onSelect={handleFileChange}
                />

                {upload && (
                    <div className="flex items-center gap-4 pt-1">
                        <span className="text-sm text-muted-foreground">{upload.name}</span>

                        <Button
                            size="sm"
                            className="bg-brand-500 text-white"
                            onClick={handleUpload}
                        >
                            {cvDoc?.fileExists ? "Replace" : "Upload"}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
